import React from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
export function Contact() {
  return <section className="w-full py-20 px-6 bg-white" data-id="element-16">
      <div className="max-w-4xl mx-auto text-center" data-id="element-17">
        <h2 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-18">Let's Connect</h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-19">
          We love hearing from our readers and community. Whether you have
          feedback, partnership ideas, questions about our content, or just want
          to say hello, feel free to reach out anytime. We're always happy to
          connect with people who share our passion for technology and digital
          innovation.
        </p>
        <div className="bg-blue-50 p-8 rounded-lg inline-block" data-id="element-20">
          <EnvelopeIcon className="w-12 h-12 text-blue-600 mx-auto mb-4" data-id="element-21" />
          <p className="text-gray-700 mb-2 font-medium" data-id="element-22">Email us at:</p>
          <a href="mailto:hello@softwarepair.com" className="text-2xl font-semibold text-blue-600 hover:text-blue-800 transition-colors" data-id="element-23">
            hello@softwarepair.com
          </a>
        </div>
        <p className="text-gray-600 mt-8 max-w-2xl mx-auto" data-id="element-24">
          We aim to respond to all inquiries within 24-48 hours. Your thoughts,
          questions, and suggestions help us continue improving and delivering
          the content that matters most to you.
        </p>
      </div>
    </section>;
}